(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup'); // Sticky bar
		const secondSection = document.querySelector('.product-section + section'); // Second section
		const footer = document.querySelector('footer'); // Footer

		// Check if the required elements exist
		if (!stickyBar || !secondSection || !footer) {
				console.error('Required elements not found!');
				return;
		}

			const getOffset = (element) => {
				const rect = element.getBoundingClientRect();
				return rect.top + window.scrollY;
			};

			const secondSectionMid = getOffset(secondSection);
			const footerTop = getOffset(footer);

			const handleScroll = () => {
				const scrollPosition = window.scrollY + window.innerHeight;
				const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop;

				stickyBar.classList[activeOffset ? "add" : "remove"]('active');
			};

			// Initial check in case the user starts in the middle of the page
			handleScroll();
	};

	document.addEventListener('scroll', () => revealPopup());

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		revealPopup();
	});

	initProductAccordion();
	initZoomImage();
	revealPopup();
	
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();

				// Bind dropdown toggle for variant select inside this floated-form (content is now in DOM)
				this.initDropdownSelect();

				// Sync to the variant that's currently selected in the main form (e.g. URL ?variant=)
				this.syncOnLoad();

				// Bi-directional sync: main ↔ floated form when either changes
				this.syncVariantChanges();
			})
			.finally(() => {
				// Ensure dropdowns get handlers even if init ran before content
				this.initDropdownSelect();
			});
	}

	syncVariantChanges() {
		if (this._variantChangeBound) return;
		this._variantChangeBound = true;

		document.addEventListener('variant:change', (e) => {
			const { variant, sectionId } = e.detail || {};
			if (!variant || !sectionId) return;

			if (!sectionId.startsWith('floated-')) {
				// Main → Floated: dispatch change so the floated form's onVariantChange runs
				// (updates its hidden id input, add-to-cart button state, etc.)
				this.syncVariantToFloated(variant);
			} else {
				// Floated → Main: update main form radio state + hidden id input
				// (no change event to avoid redundant fetch/render cycle)
				this.syncVariantToMain(variant, sectionId);
			}
		});
	}

	syncVariantToFloated(variant) {
		const floatedVariantEl = this.querySelector('variant-radios, variant-selects');
		if (!floatedVariantEl) return;

		// Update radio visual state only — no change event, so onVariantChange doesn't fire a
		// second renderProductInfo fetch that would race with the one already triggered by the main form
		variant.options.forEach((optionValue) => {
			const input = floatedVariantEl.querySelector(
				`input[type="radio"][value="${CSS.escape(optionValue)}"]`
			);
			if (input) input.checked = true;
		});

		// Keep the floated form's hidden id input in sync so its ATC submits the right variant
		this.syncFormInput(floatedVariantEl.dataset.section, variant);

		this.updateDropdownLabels(floatedVariantEl);
	}

	syncVariantToMain(variant, floatedSectionId) {
		const originalSectionId = floatedSectionId.replace(/^floated-/, '');
		const mainVariantEl = document.querySelector(
			`variant-radios[data-section="${originalSectionId}"], variant-selects[data-section="${originalSectionId}"]`
		);
		if (!mainVariantEl) return;

		// Update radio visual state only — no change event to avoid a redundant render cycle
		variant.options.forEach((optionValue) => {
			const input = mainVariantEl.querySelector(
				`input[type="radio"][value="${CSS.escape(optionValue)}"]`
			);
			if (input) input.checked = true;
		});

		// Keep the main form's hidden id input in sync so ATC on the main form submits the right variant
		this.syncFormInput(originalSectionId, variant);

		this.updateDropdownLabels(mainVariantEl);
	}

	// Updates input[name="id"] inside a product form without triggering variant re-render
	syncFormInput(sectionId, variant) {
		const form = document.getElementById(`product-form-${sectionId}`);
		if (!form) return;
		const idInput = form.querySelector('input[name="id"]');
		if (idInput && idInput.value !== String(variant.id)) {
			idInput.value = variant.id;
		}
		// Sync add-to-cart button availability
		const addButton = form.querySelector('[name="add"]');
		const addButtonText = form.querySelector('[name="add"] > span');
		if (addButton) {
			if (!variant.available) {
				addButton.setAttribute('disabled', 'disabled');
				if (addButtonText) addButtonText.textContent = window.variantStrings?.soldOut || 'Sold out';
			} else {
				addButton.removeAttribute('disabled');
				if (addButtonText) addButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
			}
		}
	}

	syncOnLoad() {
		const floatedVariantEl = this.querySelector('variant-radios, variant-selects');
		if (!floatedVariantEl) return;

		const originalSectionId = floatedVariantEl.dataset.originalSection;
		if (!originalSectionId) return;

		// Find the main section's variant element (already rendered with the URL ?variant= selected)
		const mainVariantEl = document.querySelector(
			`variant-radios[data-section="${originalSectionId}"], variant-selects[data-section="${originalSectionId}"]`
		);
		if (!mainVariantEl) return;

		// Read whichever radios are already checked in the main form and mirror them in the floated form
		// No change event — the main form's onVariantChange already handled all side effects on load
		mainVariantEl.querySelectorAll('input[type="radio"]:checked').forEach((checkedInput) => {
			const floatedInput = floatedVariantEl.querySelector(
				`input[type="radio"][value="${CSS.escape(checkedInput.value)}"]`
			);
			if (floatedInput) floatedInput.checked = true;
		});

		// Sync the floated form's hidden id input to the currently selected variant
		const mainIdInput = document.querySelector(
			`#product-form-${originalSectionId} input[name="id"]`
		);
		const floatedIdInput = document.querySelector(
			`#product-form-floated-${originalSectionId} input[name="id"]`
		);
		if (mainIdInput && floatedIdInput) {
			floatedIdInput.value = mainIdInput.value;
		}

		this.updateDropdownLabels(floatedVariantEl);
	}

	updateDropdownLabels(variantEl) {
		if (!variantEl) return;
		variantEl.querySelectorAll('.product-form__controls--dropdown').forEach((fieldset) => {
			const labelSpan = fieldset.querySelector('.dropdown-select .select-label span');
			if (!labelSpan) return;
			const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
			if (checkedInput) labelSpan.textContent = checkedInput.value;
		});
	}

	initDropdownSelect() {
		const root = this;
		const $root = $(root);
		const $dropdowns = $root.find(".product-form__controls--dropdown");
		if (!$dropdowns.length) return;

		$dropdowns.each(function () {
			const $fieldset = $(this);
			const elItem = $fieldset.find(".dropdown-select ul");
			const selectedText = $fieldset.find(".dropdown-select .select-label");
			const elListItem = $fieldset.find(".dropdown-select ul li");

			// Remove any previous handlers to avoid duplicates
			selectedText.off("click.floatedDropdown");
			elListItem.off("click.floatedDropdown");

			selectedText.on("click.floatedDropdown", function (e) {
				e.preventDefault();
				e.stopPropagation();
				elItem.toggleClass("active");
				if (elItem.hasClass("active")) {
					const $dropdown = elItem.closest(".dropdown-select");
					const closeHandler = function (e) {
						if (!$dropdown[0].contains(e.target)) {
							elItem.removeClass("active");
							$(document).off("click.floatedDropdownClose", closeHandler);
						}
					};
					setTimeout(function () {
						$(document).on("click.floatedDropdownClose", closeHandler);
					}, 0);
				}
			});

			elListItem.on("click.floatedDropdown", function (e) {
				const $li = $(this);
				if ($li.find("input").hasClass("disabled")) return;
				selectedText.find("span").text($li.text().trim()).attr("title", $li.text().trim());
				elItem.removeClass("active");
				if (document.activeElement) document.activeElement.blur();
			});
		});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		// Floated-form debugging: set window.__FLOATED_FORM_DEBUG = false to turn off
		const DEBUG = window.__FLOATED_FORM_DEBUG !== false;
		if (DEBUG) {
			console.log("[floated-form] preventDuplicatedIDs:", {
				sectionId,
				productElementId: this.productElement?.id,
				hasDatasetSection: !!this.productElement?.dataset?.section,
			});
		}

		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		const variantSelects = this.productElement.querySelectorAll("variant-selects");
		if (variantSelects.length) {
			variantSelects.forEach((el) => {
				el.dataset.originalSection = sectionId;
			});
			if (DEBUG) console.log("[floated-form] set data-originalSection on variant-selects:", variantSelects.length, "sectionId:", sectionId);
		}

		const variantRadios = this.productElement.querySelectorAll("variant-radios");
		if (variantRadios.length) {
			variantRadios.forEach((el) => {
				el.dataset.originalSection = sectionId;
			});
			if (DEBUG) console.log("[floated-form] set data-originalSection on variant-radios:", variantRadios.length, "sectionId:", sectionId);
		}

		if (DEBUG && !variantSelects.length && !variantRadios.length) {
			console.warn("[floated-form] No variant-selects or variant-radios found in productElement");
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    	const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    	const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(".product__description");
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector("pickup-availability");
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector("product-recommendations");
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);
